export default "__VITE_ASSET__DmltxQ4j__"